/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiDataRule.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-data-rule";

export class AutogenModelEdiDataRule<RowType extends ModelRow> extends Endpoint<RowType, RowEdiDataRuleFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiDataRule extends ModelRow<RowEdiDataRuleFields> {
	constructor(values?: Partial<RowEdiDataRuleFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiDataRuleFields {
	case_sensitive: string;
	company_id: string;
	data_value: string;
	error_message: string;
	id: string;
	num_of_days: number;
	operator: string;
	required_field_id: string;
	test_value: string;
}

